import {lazy} from 'react';

export const SpecialistProfileAsync = lazy(() =>
    import('./SpecialistProfile')
);
